export default __webpack_public_path__ + "static/SRF 1100M - Product Specifications & Technical Data-bb5b4ad9ab1540cf68dd6cd9d3c860b6.pdf";